var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.resolved.type === 'category')?[_c('category',{attrs:{"category":_vm.resolved}})]:(_vm.resolved.type === 'product')?[_c('product',{attrs:{"product":_vm.resolved}})]:(_vm.resolved.type === 'color')?[_c('color-page',{attrs:{"resolve":_vm.resolved}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }